/** Full-site "down for maintenance" gate — shown to every non-admin visitor while
 * maintenance_mode is enabled (SystemSettingsPage, SUPER_ADMIN/PLATFORM_ADMIN only). Distinct
 * from pages/MaintenancePage.tsx, which is an unrelated property-maintenance-tickets dashboard
 * page. */
export function MaintenanceModePage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center px-6">
        <h1 className="text-2xl font-semibold text-gray-800">We&apos;ll be right back</h1>
        <p className="mt-2 text-gray-500 max-w-md">
          BookBed is temporarily down for maintenance. Please check back shortly.
        </p>
      </div>
    </div>
  );
}

export default MaintenanceModePage;
